import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-almacen-equipos',
  templateUrl: './almacen-equipos.component.html',
  styleUrls: ['./almacen-equipos.component.css']
})
export class AlmacenEquiposComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
